import { useEffect, useState } from 'react';

const TIME_ZONES = {
  ET: 'America/New_York',
  PT: 'America/Los_Angeles',
};

export const useDateSolver = ({
  type,
  air_date,
  start_date,
  start_date_timestamp,
  end_date_timestamp,
  desc,
  date,
  time,
}) => {
  const [result, setResult] = useState({
    dateToShow: '',
    isLive: false,
  });

  useEffect(() => {
    const currentTime = new Date().getTime();

    if (type === 'webinars') {
      const startTime = start_date_timestamp
        ? start_date_timestamp * 1000
        : new Date(air_date).getTime();
      // we assume that event end time is start time + 90 minutes if end
      const endTime = end_date_timestamp
        ? end_date_timestamp * 1000
        : startTime + 5400000;

      const isLive = currentTime > startTime && currentTime < endTime;

      setResult({
        dateToShow: desc || `${date} at ${time}`,
        isLive,
      });
    } else {
      const startDate = new Date(air_date);
      const endDate = new Date(startDate.getTime() + 5400000);
      const etStartDate = startDate.toLocaleString('en-US', {
        timeZone: TIME_ZONES.ET,
        month: 'short',
        day: 'numeric',
      });
      const ptStartDate = startDate.toLocaleString('en-US', {
        timeZone: TIME_ZONES.PT,
        month: 'short',
        day: 'numeric',
      });
      const etStartTime = startDate.toLocaleString('en-US', {
        timeZone: TIME_ZONES.ET,
        hour: 'numeric',
        hour12: true,
        minute: '2-digit',
      });
      const etEndTime = endDate.toLocaleString('en-US', {
        timeZone: TIME_ZONES.ET,
        hour: 'numeric',
        hour12: true,
        minute: '2-digit',
      });
      const ptStartTime = startDate.toLocaleString('en-US', {
        timeZone: TIME_ZONES.PT,
        hour: 'numeric',
        hour12: true,
        minute: '2-digit',
      });
      const ptEndTime = endDate.toLocaleString('en-US', {
        timeZone: TIME_ZONES.PT,
        hour: 'numeric',
        hour12: true,
        minute: '2-digit',
      });
      const shouldShowPtDate = etStartDate !== ptStartDate;

      const etDateString = `${etStartDate} at ${etStartTime} - ${etEndTime} ET`;
      const ptDateString = `${
        shouldShowPtDate ? ptStartDate : ''
      } ${ptStartTime} - ${ptEndTime} PT`;

      const dateToShow = `${etDateString} / ${ptDateString}`;

      const startTime = new Date(air_date || start_date).getTime();
      const endTime = startTime + 5400000;
      const isLive = currentTime > startTime && currentTime < endTime;

      setResult({
        dateToShow,
        startDate,
        endDate,
        isLive,
      });
    }
  }, [air_date, start_date, end_date_timestamp, type, desc, date, time, start_date_timestamp]);
  return result;
};
